import Select from '@app/src/components/Form/Select/ControlledSelect'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'
import type { ExpectationAutomationFormData } from '../types'
import { ExpectationAutomationFormField, SupplierRiskOption } from '../types'

const SUPPLIER_RISK_OPTION_KEYS: { value: SupplierRiskOption; labelId: string }[] = [
  { value: SupplierRiskOption.Any, labelId: 'form.createExpectationAutomation.riskStatus.anyOption' },
  { value: SupplierRiskOption.Extreme, labelId: 'schemas.risk.status.FExtreme' },
  { value: SupplierRiskOption.HighOrExtreme, labelId: 'form.createExpectationAutomation.riskStatus.highOption' },
  { value: SupplierRiskOption.MediumOrHigher, labelId: 'form.createExpectationAutomation.riskStatus.mediumOption' },
]

const SetRiskStatusStep: React.FC = () => {
  const { formatMessage } = useIntl()
  const { control } = useFormContext<ExpectationAutomationFormData>()

  const options = SUPPLIER_RISK_OPTION_KEYS.map(({ value, labelId }) => ({
    label: formatMessage({ id: labelId }),
    value,
  }))

  return (
    <Select<SupplierRiskOption>
      name={ExpectationAutomationFormField.HighestAllowedProviderRiskStatus}
      fieldLabel={formatMessage({ id: 'navbar.providerRisk.supplier' })}
      control={control}
      required
      options={options}
    />
  )
}

export default SetRiskStatusStep
